// @ts-nocheck
import { Card, CardBody, CardExpandToggler } from '../../../components/card/card.jsx';
import CountUp from 'react-countup';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployees } from '../../../store/HR/Person/employeeSlice.js';
import Loading from '../../../components/Shared/Loader/Loading';
import EmployeeByOrg from './EmployeeByOrg.jsx';
import EmployeeByNationality from './EmployeeByNationality';
import { Icon } from '@iconify/react';
// import VacanciesByDepartment from './VacanciesByDepartment .jsx';
// import Pie from '../../dashboard/Pie.jsx';
import Breadcrumb from '../../../components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';

const HrDashBoard = () => {
  const { t } = useTranslation();

  //#region Employees Counts
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      if (Employees?.length === 0) {
        await dispatch(getEmployees());
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const { Employees, loading, error } = useSelector(state => state.Employees);
  var totalEmployees = Employees?.length;
  var employeesCurrentlyWorking = Employees?.filter(f => f.endOfServiceDate === null)?.length;
  var employeesEndedService = Employees?.filter(f => f.endOfServiceDate !== null)?.length;
  //#endregion
  const [leaveData] = useState({
    series: [60, 40], // مستخدم، متبقي
    labels: ['إجازات مستهلكة', 'إجازات متبقية']
  });

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: null
          }
        ]}
      />
      <Loading loading={loading} error={error}>
        <>
          <div className='row'>
            <div className='col-lg-3'>
              <Card className='mb-3'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3'>
                    <span className='flex-grow-1'>{t('TotalEmployees')}</span>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-7'>
                      <h1 className='mb-0 ps-4 text-theme '>
                        <CountUp end={totalEmployees} duration={2.5} />
                      </h1>
                    </div>
                    <div className='col-5 text-center'>
                      <div className='mt-n2 ps-4'>
                        <Icon icon='mdi:account-group-outline' className='fa-4x text-theme' />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className='col-lg-3'>
              <Card className='mb-3'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3'>
                    <span className='flex-grow-1'>{t('EmployeesOnTheJob')}</span>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-7'>
                      <h1 className='mb-0 ps-4  text-theme'>
                        <CountUp end={employeesCurrentlyWorking} duration={2.5} />
                      </h1>
                    </div>
                    <div className='col-5 text-center'>
                      <div className='mt-n2 ps-4'>
                        <Icon icon='mdi:account-tie-outline' className='fa-4x text-theme' />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className='col-lg-3'>
              <Card className='mb-3'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3'>
                    <span className='flex-grow-1'>{t('EmployeesServicesHaveEnded')}</span>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-7'>
                      <h1 className='mb-0 ps-4  text-theme'>
                        <CountUp end={employeesEndedService} duration={2.5} />
                      </h1>
                    </div>
                    <div className='col-5 text-center'>
                      <div className='mt-n2 ps-4'>
                        <Icon icon='mdi:account-off-outline' className='fa-4x text-theme' />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className='col-lg-3'>
              <Card className='mb-3'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3'>
                    <span className='flex-grow-1'>{t('EmployeesOnLeave')}</span>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-7'>
                      <h1 className='mb-0 ps-4  text-theme'>0</h1>
                    </div>
                    <div className='col-5 text-center'>
                      <div className='mt-n2 ps-4'>
                        <Icon icon='mdi:calendar-check-outline' className='fa-4x text-theme' />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>

          <div className='row'>
            <div className='col-xl-6'>
              <EmployeeByNationality />
            </div>

            <div className='col-xl-6'>
              <EmployeeByOrg />
            </div>
            {/* <div className="col-xl-6">
              <VacanciesByDepartment />
            </div>
            <div className="col-lg-6">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody className="">
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">الإجازات المستخدمة والمتبقية</span>
                    <CardExpandToggler />
                  </div>
                  <div className="">
                    <Pie labels={leaveData.labels} series={leaveData.series} height={400} />
                  </div>
                </CardBody>
              </Card>
            </div> */}
          </div>
        </>
      </Loading>
    </div>
  );
};

export default HrDashBoard;
